<template>
  <div v-if="questionData.options" :class="classes">
    <div
      v-for="(option, index) in questionData.options"
      :key="index"
      class="trbo-a-gallery__item"
    >
      <gallery-item
        :option="option"
        :is-selected="isSelected(option)"
        @select="onSelect"
      />
    </div>
  </div>
</template>

<script>
// @flow

import GalleryItem from './GalleryItem/GalleryItem.vue'

export default {
  components: {
    GalleryItem
  },
  props: {
    question: {
      type: Object, // WizardPage
      required: true
    },
    questionData: {
      type: Object, // WizardPageData<SingleChoiceData>
      required: true
    },
    selected: {
      type: String,
      default: null
    }
  },
  computed: {
    classes () {
      return {
        'trbo-a-gallery': true,
        'trbo-a-gallery--align-left': this.questionData.options?.length > 2
      }
    }
  },
  methods: {
    onSelect (option) {
      const { question } = this
      this.$emit('select', { question, option })
    },
    isSelected (option) {
      return option.uuid === this.selected
    }
  }
}
</script>

<style scoped src="./gallery.scss" />
